export const dateFormatForOrderedDate = "ll";
export const datePickerFormat = "dddd, MM/DD/YYYY";
export const dateFormatForApiRequest = "YYYY-MM-DD";
export const standardDateFormat = "MM/DD/YY";
export const standardDateFormatFullYear = "MM/DD/YYYY";
export const standardDateFormatDatePicker = "MM/dd/yy";
export const dayFirstFormatFullYear = "DD/MM/YYYY";
